import { createContext, useContext, useState } from "react";

import { chosenSites as chosenSitesService } from "app/common/services/chosenSites";
import type { ILegendItems } from "app/components/React/Legends/legendsTypes";
import { websiteWorldWideOverviewLogic } from "app/pages/website-performance/helpers/websitePerformanceHelpers";

import type { IChosenItems } from "../../../../@types/chosenItems";

interface IParams {
    country: number;
    duration: string;
    key: string;
    isWWW: string;
}

export interface ISocialTrafficContext {
    params: IParams;
    chosenSites: IChosenItems;
    legendItems: ILegendItems;
    setLegendItems: (legendItems: ILegendItems) => void;
    apiController: string;
}

export const SocialTrafficContext = createContext<ISocialTrafficContext>(null);
export const useSocialTrafficContext = (): ISocialTrafficContext => useContext(SocialTrafficContext);

export const getInitialContext = (params) => {
    let { duration } = params;
    const { apiController, isWWWithoutPermissions } = websiteWorldWideOverviewLogic(params.country.toString());
    if (isWWWithoutPermissions) {
        duration = "3m";
    }
    const chosenSites = chosenSitesService.sitelistForLegend();
    const initialLegends = chosenSites.map((chosenSite) => {
        return { ...chosenSite, visible: true };
    });
    const initialState = {
        params: { ...params, duration },
        chosenSites,
        legendItems: initialLegends,
        apiController,
    };
    const [state, setState] = useState(initialState);
    return {
        ...state,
        setLegendItems: (legendItems) => {
            setState({
                ...state,
                legendItems,
            });
        },
    };
};
